import routes from './routes'
import * as repositories from './repositories'
import * as stores from './stores'

export default {
  routes,
  repositories,
  stores,
}
